export enum LossContractType {
  NONE = 'NONE',
  ONE_PERCENT_LOSS_COVERAGE = 'ONE_PERCENT_LOSS_COVERAGE',
  STOCK_LOSS = 'STOCK_LOSS',
}
